import { createFileRoute } from "@tanstack/react-router";

import Forbidden from "@/components/forbidden";

export const Route = createFileRoute("/(error)/page-forbidden")({
  component: Forbidden,
});
